import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/terms/terms.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/opt/build/repo/src/components/ui/PageContent/PageContent.tsx");
